import uuid from 'uuid/v4'

class PortalRegistry {
  constructor () {
    this.portals = {}
    this.destinations = {}
  }

  subscribe = (cb, channel) => {
    this.destinations[channel] = this.destinations[channel] || []
    this.destinations[channel].push(cb)
    return this.portals[channel] || {}
  }

  notifySubscriber = (channel) => {
    (this.destinations[channel] || []).forEach((subscriber) => subscriber(this.portals[channel]))
  }

  registerPortal = (channel, portal) => {
    const id = uuid()
    if (!this.portals[channel]) this.portals[channel] = {}
    this.portals[channel][id] = portal
    this.notifySubscriber(channel)
    return id
  }

  unregisterPortal = (channel, id) => {
    delete this.portals[channel][id]
    this.notifySubscriber(channel)
  }

  updatePortal = (channel, id, portal) => {
    this.portals[channel][id] = portal
    this.notifySubscriber(channel)
  }
}

export default PortalRegistry
